module.exports = __webpack_public_path__ + "images/pages/lp/title_3240134002eb93602e798fa253ede483.png";